<template>
  <div
    class="Scenes"
    :style="{
      width: MaterialPane_Size.width - 92 + 'px',
      height: MaterialPane_Size.height + 'px',
    }"
  >
    <div class="inner">
      <div class="topBar">
        <div class="newBtn" @click="addScenes()">
          <div></div>
          <span>新建空白</span>
        </div>
        <div class="scenesBtn" @click="OpenScenesLib()">
          <div></div>
          <span>场景库</span>
        </div>
      </div>
      <div class="labelNum" v-show="scenesData && scenesData.length">
        {{ SelectScenes_Msg.index + 1 }}/{{ scenesData.length }}页
      </div>

      <div class="scenesGrid">
        <div class="scenes-loading-wrapper" v-show="isShowScenesLoading">
          <div
            class="scenes-loading"
            v-loading="true"
            style="margin-top: 100px"
          ></div>
        </div>

        <div class="scenesArray" @scroll="onListScroll">
          <draggable
            id="scenesDrag"
            v-model="scenesData"
            :options="dragOptions"
            :move="onMove"
            @end="onEnd"
          >
            <div
              class="scenesList scenesThumbnails"
              v-for="(item, index) in scenesData"
              :key="item.data.id"
              :style="{
                height:
                  SelectScenes_Msg.id === item.data.id ? '214px' : '208px',
              }"
              :class="{ active: SelectScenes_Msg.id === item.data.id }"
              ref="thumbnailRef"
              :data-id="item.data.id"
              @mouseleave="closeSetting($event)"
              @click="stopDocument($event)"
              @mousedown="ctrlSelect"
              @contextmenu="stopcontextmenu"
              @keyup="senseHotKey"
            >
              <div
                class="scenes_animation"
                v-if="index > 0"
                @click="openSceneEffectPopup(item.data.id, $event)"
              >
                <!-- <div> -->
                <el-tooltip
                  effect="dark"
                  content="转场动画，在两个页面间添加动画效果"
                  placement="right"
                  :open-delay="1000"
                >
                  <i
                    class="iconfont iconzhuanchang"
                    :class="{
                      active:
                        getDisplayEffectName(index, scenesData) !== 'None',
                    }"
                  ></i>
                </el-tooltip>
                <!-- </div> -->
                <span>{{ getEffectName(index, scenesData) }}</span>
              </div>
              <div
                class="thumbnails"
                :class="{
                  thumbnails_s: SelectScenes_Msg.id === item.data.id,
                  thumbnails_c: SelectScenes_Msg.id !== item.data.id,
                }"
              >
                <div
                  v-html="item.thumbnails"
                  class="htmlT"
                  :style="{
                    transform:
                      SelectScenes_Msg.id === item.data.id
                        ? 'scale(' +
                          item.seleceScale +
                          ',' +
                          item.seleceScale +
                          ')'
                        : 'scale(' + item.scale + ',' + item.scale + ')',
                  }"
                ></div>
                <div
                  class="thumbnailsMask"
                  @click="setSelectScenes(item.data)"
                  :class="{
                    verticalMask: TOOL.optimized == 'Vertical',
                    verticalMaskWiidth: SelectScenes_Msg.id !== item.data.id,
                  }"
                  :id="item.data.id"
                >
                  <div
                    class="maskBtn"
                    v-if="SelectScenes_Msg.id === item.data.id"
                    :id="item.data.id"
                  >
                    <!-- <div
                        class="scenesSetting el-icon-more"
                        @click="scenesSetting($event, item.data, index)"
                        @mouseleave="clearTimeoutFS()"
                    ></div>-->
                    <!-- 复制场景 -->
                    <el-tooltip
                      effect="dark"
                      content="复制"
                      placement="bottom"
                      :open-delay="1000"
                    >
                      <div class="btn-bg" :style="{ top: '6px', left: '6px' }">
                        <div
                          class="scenes-copy"
                          @click.stop="copyScenes(item.data, index)"
                        ></div>
                      </div>
                    </el-tooltip>
                    <!-- 继续创做 -->
                    <el-tooltip
                      effect="dark"
                      content="继续创作"
                      placement="bottom"
                      :open-delay="1000"
                    >
                      <div
                        class="btn-bg"
                        :style="{ top: '6px', right: '66px' }"
                      >
                        <div
                          class="scenes-continue"
                          @click.stop="continueScenes(item.data, index)"
                        ></div>
                      </div>
                    </el-tooltip>
                    <!-- 收藏场景 -->
                    <el-tooltip
                      effect="dark"
                      content="收藏"
                      placement="bottom"
                      :open-delay="1000"
                    >
                      <div
                        class="btn-bg"
                        :style="{ top: '6px', right: '36px' }"
                      >
                        <div
                          class="scenes-collect"
                          :class="{ active: item.data.favorites }"
                          @click.stop="collectScenes(item.data, index, item)"
                        >
                          <i class="iconfont iconshoucang1"></i>
                        </div>
                      </div>
                    </el-tooltip>
                    <!-- 删除 -->
                    <el-tooltip
                      effect="dark"
                      content="删除"
                      placement="bottom"
                      :open-delay="1000"
                    >
                      <div class="btn-bg" :style="{ top: '6px', right: '6px' }">
                        <div
                          class="scenesRm"
                          @click.stop="scenesRm(item.data, index)"
                        ></div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <!-- 场景时长 -->
                <div class="scene-duration">
                  {{ item.data.duration / 1000 + "S" }}
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "@/plugins/vuedraggable";
import { mapGetters, mapMutations, mapActions } from "vuex";
import fromPPT from "./scenes/fromPPT.vue";
import domtoimage from "dom-to-image";

function sequenceTasks(tasks) {
  function recordValue(results, value) {
    results.push(value);
    return results;
  }
  var pushValue = recordValue.bind(null, []);
  return tasks.reduce(function (promise, task) {
    return promise.then(task).then(pushValue);
  }, Promise.resolve());
}

export default {
  data() {
    return {
      ANALYSIS: {
        addScenes: {
          category: "resource_scene",
          action: "click_add_empty_scene",
          label: "资源设置_场景_添加_空白场景页",
        },
      },
      scenesHide: false, // 判断scenes是否存在
      scenesData: [], // scenes数据
      moveAction: true, // 移动控制元素
      effectNames: {
        UpIn: "向上移",
        DownIn: "向下移",
        LeftIn: "向左移",
        RightIn: "向右移",
        None: "无动画",
      },
      addtime: null,
      sceneSetTimeout: "",
      nextIndex: {
        index: 0,
        action: false,
      },
      scenesFlag: false,
      // isShowScenesLoading: true,
      isUploadingScene: false,
    };
  },
  computed: {
    ...mapGetters([
      "MaterialPane_Size",
      "TOOL",
      "SelectScenes_Msg",
      "IsVipSprites",
      "UserEquity", // 用户权益
      "UserMsg",
    ]),
    ...mapGetters({
      soundHandle: "addSoundtrack/getPlayHandle"
    }),
    isShowScenesLoading: {
      get () {
        return this.$store.getters['materialArea/isShowScenesLoading'];
      },
      set (val) {
        this.$store.commit('materialArea/isShowScenesLoading', val);
      }
    },
    dragOptions() {
      return {
        disabled: this.judgedrag, // 控制开关
        scroll: true, // 开启滚动
        scrollSensitivity: 150, // 滚动区域
        animation: 100,
        group: {
          put: false, // 单组拖拽
          name: "scenesDrag",
        },
        rmgroup: "", // 保存的删除分组
        moveScenesMsg: null,
      };
    },
    sceneShowing() {
      return (
        this.MaterialPane_Size &&
        typeof this.MaterialPane_Size.width === "number" &&
        this.MaterialPane_Size.width >= 223
      );
    },
  },
  watch: {
    TOOL(val) {
      if (val) {
        this.TOOL.eve.on(
          "sceneSprite.unLoadData.fromJsonLoadingState",
          function h(data) {
            if (data && data.state < 2) {
              window.riskLocating ||
                this.$store.commit("open_FirstTemplateLoading");
            } else {
              this.$store.commit("close_FirstTemplateLoading");
            }
          }.bind(this)
        );
      }
    },
    "TOOL.sprites": function (val, oldval) {
      // 判断打开关闭
      if (this.moveAction) {
        if (this.nextIndex.action) {
          for (var i = 0; i < this.TOOL.sprites.length; i++) {
            if (this.TOOL.sprites[i].index === this.nextIndex.index) {
              this.setSelectScenes(this.TOOL.sprites[i]);
              this.nextIndex.action = false;
              break;
            }
          }
        }
        this.scenesData = [];
        if (this.scenesFlag) {
          this.getScenesData();
        }
      }
    },
    "TOOL.clickJudge": function (val, oldval) {
      // clickJudge
      if (this.TOOL && this.TOOL.clickJudge && this.moveScenesMsg) {
        return;
      }
      // console.log('clickJudge')
      this.moveScenesMsgFs(this.SelectScenes_Msg.id);
    },
    "SelectScenes_Msg.background.filter": {
      handler() {
        this.moveScenesMsgFs(this.SelectScenes_Msg.id);
      },
    },
    "SelectScenes_Msg.background.data.data.opacity": {
      handler() {
        this.moveScenesMsgFs(this.SelectScenes_Msg.id);
      },
    },
    SelectScenes_Msg: function (val, oldval) {
      //console.log("SelectScenes_Msg scenesData",this.scenesData)
    },
    scenesData: function (val, oldval) {
      for (let index = 0; index < this.scenesData.length; index++) {
        let item = this.scenesData[index];
        item.ctrlSelect = false;
        if (item.data.id == this.SelectScenes_Msg.id) item.ctrlSelect = true;
      }
      //this.TOOL.selectSprite([sprite]);
      // console.log(
      //   "SelectScenes_Msg scenesData",
      //   this.SelectScenes_Msg,
      //   this.scenesData
      // );
    },
    // scenesData (val) {
    //   if (val && !val.length) {
    //     this.isShowScenesLoading = true;
    //   }
    // }
  },
  created() {
    this.$bus.on("showScenesLoading", (flag) => {
      this.isShowScenesLoading = flag;
    });
  },
  mounted() {
    this.$bus.on("changeSelectScenes_vue", (data) => {
      // 单个场景元素改变
      if (this.TOOL && this.TOOL.clickJudge && this.moveScenesMsg) {
        return;
      }
      this.moveScenesMsg = data;
      this.moveScenesMsgFs(this.SelectScenes_Msg.id);
    });
    this.$bus.on("updateSprite_vue", (data) => {
      // 元素修改
      this.moveScenesMsgFs(data.scenesId);
    });

    // 背景改变时通知这里
    this.$bus.on("bgSetting.updateLeftSide", () => {
      this.moveScenesMsgFs(this.SelectScenes_Msg.id);
    });

    this.$bus.on("updateAllScenes", (...args) => {
      this.TOOL.updateSoundRecordBackup();
      this.updateScenes(...args);
    });
    this.$bus.on("scenesRm_vue", (data) => {
      this.scenesRm(data.data, data.index);
    });
    this.$bus.on("addScenes_vue", (data) => {
      this.addScenes();
    });
    eve.on("videoBgCurrentTimeChange", ({ scene, currentTime } = {}) => {
      // console.log({$el: $(this.$el).find(`[data-url="video-mark_${scene.id}"]`)})
      $(this.$el)
        .find(`[data-url="video-mark_${scene.id}"]`)
        .prop("currentTime", currentTime);
    });

    eve.on("videoSprite.updateCurrentTime", () => {
      this.syncVideoSpriteTime(this.SelectScenes_Msg);
    });

    eve.on("editor.groupListPush", (data) => {
      // 组合元素添加
      this.$bus.emit("judgeItemPayType_vue", {
        type: "groupSprites",
        id: data.data.id,
        option: {
          type: data.data.type,
          fileType: data.data.fileType, // 背景资源type
          resourceId: data.data.resourceId, // 背景资源id
        },
        opHelper: {
          isSvip: false,
        },
        scenesId: data.id,
      });
    });

    eve.on("editor.groupListRemove", (data) => {
      // 组合元素删除
      this.$store.commit("del_vipSprites", { id: data.data.id });
    });

    // 一个场景视频数量限制所触发的操作
    eve.on("addVideo.bg", (data) => {
      setTimeout(() => {
        this.$bus.emit("changeSelectScenes_vue", data);
      }, 1000);
    });

    eve.on("sceneBgAdded", () => {
      setTimeout(() => {
        this.moveScenesMsgFs(this.SelectScenes_Msg.id);
      }, 500);
    });

    // this.TOOL.eve.on("sceneSprite.unLoadData.fromJsonLoadingState", function h(data) {
    //   console.log('eve.on("sceneSprite.unLoadData.fromJsonLoadingState"', data)
    //   if (data && data.state < 2) {
    //     this.$store.commit("open_FirstTemplateLoading");
    //   } else {
    //     this.$store.commit("close_FirstTemplateLoading");
    //   }
    // }.bind(this));
    //this.oncontextmenu = function(){return false;}
  },
  methods: {
    ...mapMutations({
      setSceneLibStatus: "materialArea/setSceneLibStatus",
    }),
    ...mapActions({
      likes: "resources/likes",
      uploadImage: "resources/uploadImage",
      uploadScene: "resources/uploadScene",
    }),
    hideScenes() {
      if (this.scenesHide) {
        this.$store.commit("save_Scenes", { width: 223 });
        this.scenesHide = false;
      } else {
        this.$store.commit("save_Scenes", { width: 23 });
        this.scenesHide = true;
      }
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "Scenes",
      });
    },
    OpenScenesLib() {
      this.setSceneLibStatus("pack-enter");
      this.$emit("changePackIndex", 10);
    },
    getScenesData() {
      if (this.scenesData && this.scenesData.length) {
        this.scenesData = [];
      }
      let tasks = [];
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        let dataMsg = {
          data: this.TOOL.sprites[i],
          thumbnails: "",
        };
        tasks[tasks.length] = this.TOOL.sprites[i]
          .getThumbnails()
          .then((data) => {
            if (!data) {
              return;
            }
            dataMsg.thumbnails = data.dom;
            (this.scenesData[i] || {}).seleceScale = 260 / data.width;
            (this.scenesData[i] || {}).scale = 242 / data.width;

            // this.syncVideoBgTime(this.TOOL.sprites[i]);
          });
        this.scenesData.push(dataMsg);
      }

      // if (
      //   "sceneNum" in this.UserEquity &&
      //   this.scenesData.length >= this.UserEquity.sceneNum
      // ) {
      //   if (this.UserMsg.level > 0) {
      //     this.$bus.emit("FeaturesPop_vue", {
      //       name: "vipEquity",
      //       msg: "您当前最多只能添加20个场景，开通企业会员，可无限使用。",
      //       btnMsg: "立即开通",
      //       btnMsgLink: "/workplace/vip",
      //       type: 2
      //     });
      //   } else {
      //     this.$bus.emit("FeaturesPop_vue", {
      //       name: "vipEquity",
      //       msg: "您当前最多只能添加10个场景，升级个人VIP，可扩充到20个。",
      //       btnMsg: "立即开通",
      //       btnMsgLink: "/workplace/vipsolo",
      //       recommendVip: "场景页数量无限制，点击了解高级会员",
      //       type: 2
      //     });
      //   }
      // }
      Promise.all(tasks).then(() => {
        this.syncVideoSpritesAndVideoBg();
      });
    },
    stopcontextmenu(e) {
      return;
      //多选时阻止右键菜单
      e.preventDefault();
      return false;
    },
    ctrlSelect(e) {
      return;
      //场景页多选
      var ctrlKey = e.ctrlKey || e.metaKey;
      if (ctrlKey) {
        for (let index = 0; index < this.scenesData.length; index++) {
          let item = this.scenesData[index];
          if (
            item.data.id == e.target.id &&
            item.data.id !== this.SelectScenes_Msg.id
          )
            item.ctrlSelect = !item.ctrlSelect;
        }
        console.log(
          "TCL: ctrlSelect -> ctrlSelect",
          e.target,
          this.SelectScenes_Msg,
          this.scenesData
        );
        e.preventDefault();
        return false;
      }
      //监听画布选中状态 SelectSprites_Msg
    },
    senseHotKey(e) {
      return;
      console.log("TCL: senseHotKey -> senseHotKey", e);
      //组合键
    },
    setSelectScenes(data) {
      if (this.SelectScenes_Msg.id !== data.id) {
        for (var k in this.SelectScenes_Msg.sprites) {
          //this.SelectScenes_Msg.sprites[k].effect.unInitActiveResource();
          if (this.SelectScenes_Msg.sprites[k].type == "Lottie") {
            this.SelectScenes_Msg.sprites[k].unActiveAnimation();
          }
        }
        // 切换
        this.TOOL.selectScenes(data).then(() => {
          if (data.fromJsonLoadingState < 1 && data.unLoadData.json) {
            let json = data.unLoadData.json;
            // json.sprites = json.sprites.filter(v => v.type != 'Text');
            //console.log('if (data.fromJsonLoadingState < 1)', data)
            let _this = this;
            data.fromJson(
              json,
              this.TOOL.clientWidth / data.unLoadData.resolutionWidth,
              true
            );
          } else {
            //场景页已经加载
            this.$store.commit("open_FirstTemplateLoading");
            this.SelectScenes_Msg.activeAnimation()
              .then(() => {})
              .finally(() => {
                this.$store.commit("close_FirstTemplateLoading");
              });
          }
        });
      }
    },
    onMove(evt) {
      // 移动
      if (evt) {
        this.moveAction = false;
      }
    },
    onEnd(evt) {
      // let dragged = evt.draggedContext.element.data;
      // let related = evt.relatedContext.index;
      // 结束
      if (evt) {
        let id = evt.item.dataset.id;
        let index = evt.newIndex;
        this.moveAction = true;
        if (id !== this.SelectScenes_Msg.id) {
          this.setSelectScenes(this.TOOL.getScenesIdData(id));
        }
        if (this.SelectScenes_Msg.index === index) return;

        let changeTime = [0, 0, 0, 0];
        let canBreak = -1;
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          let s = this.TOOL.sprites[i];
          if (s.id === id) {
            changeTime[1] += changeTime[0] + s.duration / 1000;
            canBreak++;
          }
          if (i === index) {
            if (index > this.SelectScenes_Msg.index) {
              changeTime[2] += s.duration / 1000;
            }
            changeTime[3] = changeTime[2];
            canBreak++;
          }
          if (changeTime[1] === 0) {
            changeTime[0] += s.duration / 1000;
          }
          if (changeTime[3] === 0 && index) {
            changeTime[2] += s.duration / 1000;
          }
          if (canBreak > 0) {
            break;
          }
        }
        this.soundHandle.swapScenesSound(changeTime);
        this.$store.commit("subtitle/swapScenesSound", changeTime);

        this.TOOL.moveScenesTo(id, index, true);
      }
      if (evt.newIndex === 0) {
        // -- 移动到第一位，去掉动画
      }
    },
    addScenes() {
      // this.emitDurationLimit();
      // 添加scenes
      let scenesIndex = this.SelectScenes_Msg.index + 1;
      let changeTime = [0, 0];
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        changeTime[0] += this.TOOL.sprites[i].duration / 1000;
        if (this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
          break;
        }
      }

      this.TOOL.addScenes(null, null, true).then((scenes) => {
        this.TOOL.selectScenes(scenes).then((data) => {
          this.TOOL.moveScenesTo(scenes.id, scenesIndex);
          scenes.fromJsonLoadingState = 2;
          changeTime[1] = changeTime[0] + scenes.duration / 1000;
          this.soundHandle.addScenesSound(changeTime, []);
          this.$store.commit("subtitle/addScenesSound", {
            changeTime,
            subtitles: [],
          });
          this.emitDurationLimit();
        });
      });
    },
    scenesSetting(e, data, index) {
      // 设置setting
      if (data) {
        this.sceneSetTimeout = setTimeout(() => {
          this.$bus.emit("FeaturesPop_vue", {
            type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
            name: "scenesSetting",
            sprite: data,
            spriteIndex: index,
            posx: e.pageX - e.offsetX + 38, // 弹窗的定位
            posy: e.pageY - e.offsetY,
          });
          this.addtime = true;
        }, 100);
      }
    },
    clearTimeoutFS() {
      clearTimeout(this.sceneSetTimeout);
    },
    closeSetting(e) {
      if (e.target.className.indexOf("scenesList") >= 0 && this.addtime) {
        this.addtime = false;
        this.$bus.emit("setTimeOut_vue", {
          name: "scenesSetting",
        });
      }
    },
    scenesRm(data, index) {
      this.$store.commit("del_vipSprites", { id: "BG-" + data.id });
      if (this.TOOL.sprites.length > 1) {
        this.nextIndex.index =
          index === this.TOOL.sprites.length - 1 ? index - 1 : index;
        this.nextIndex.action = true;
        let changeTime = [0, 0];
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          if (this.TOOL.sprites[i].id === data.id) {
            changeTime[1] =
              changeTime[0] + this.TOOL.sprites[i].duration / 1000;
            break;
          }
          changeTime[0] += this.TOOL.sprites[i].duration / 1000;
        }
        let dubbingArr = this.soundHandle.getDubbingTS(changeTime);
        let subtitles = [];
        this.$store.commit("subtitle/getSubtitleTS", {
          timeSlot: changeTime,
          subtitles,
        });
        this.soundHandle.delScenesSound(changeTime);
        this.$store.commit("subtitle/delScenesSound", changeTime);
        this.TOOL.removeScenes(data.id, true, {
          dubbing: dubbingArr,
          subtitles,
        });
        this.emitDurationLimit();
      } else {
        // 清空配音
        this.soundHandle.clearSound("dubbing");
        this.$store.commit("subtitle/clearSubtitles");
        this.TOOL.addScenes(null, null, true).then((scenes) => {
          this.emitDurationLimit();
          let timeoutid = setTimeout(() => {
            this.TOOL.removeScenes(data.id, true).then((data) => {
              this.TOOL.selectScenes(scenes);
            });
            clearTimeout(timeoutid);
          }, 200);
        });
      }
    },
    copyScenes(data, index) {
      // 复制分组
      let timeSlot = [0, 0];
      let changeTime = [0, 0];
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        changeTime[0] += this.TOOL.sprites[i].duration / 1000;
        if (this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
          changeTime[1] = changeTime[0] + this.SelectScenes_Msg.duration / 1000;
          timeSlot[1] = timeSlot[0] + this.SelectScenes_Msg.duration / 1000;
          break;
        }
        timeSlot[0] += this.TOOL.sprites[i].duration / 1000;
      }
      let soundArr = this.soundHandle.getDubbingTS(timeSlot);
      let addSounds = [];
      if (soundArr && soundArr.length) {
        let dub = null;
        for (let i = 0; i < soundArr.length; i++) {
          dub = soundArr[i];
          addSounds.push({
            id: dub.resourceId,
            title: dub.title,
            fileType: dub.fileType,
            url: dub.url,
            timeSlot: [
              changeTime[0] + dub.timeSlot[0],
              changeTime[0] + dub.timeSlot[1],
            ],
            cut: [...dub.cut],
          });
        }
      }
      let subtitles = [];
      let subtitleArr = [];
      this.$store.commit("subtitle/getSubtitleTS", { timeSlot, subtitles });
      for (let i = 0; i < subtitles.length; i++) {
        subtitleArr.push(Object.assign({}, subtitles[i]));
        subtitles[i].startTime += changeTime[0];
        subtitles[i].endTime += changeTime[0];
      }
      let scenesJson = this.cardingCopyJson(this.SelectScenes_Msg.toJson());
      let scale = this.TOOL.clientWidth / scenesJson.resolution.width;
      let scenesIndex = this.SelectScenes_Msg.index + 1;
      this.TOOL.addScenes().then((scenes) => {
        this.TOOL.selectScenes(scenes).then((data) => {
          this.TOOL.moveScenesTo(scenes.id, scenesIndex);
          this.SelectScenes_Msg.toFromJson(scenesJson, scale).then(() => {
            // 复制进入undo栈
            let data = scenes.toJson(true);
            data.dubbing = soundArr;
            data.subtitles = subtitleArr;
            data.scale = this.TOOL.scale;
            this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
            eve("undo_redo", null, { type: "copyScenes", data: data });

            this.$bus.emit("judgeItemPayType_vue", {
              type: "scenes",
              id: data.id,
              option: {
                resourceId: data.resourceId, // 背景资源id
                fileType: 24, // 背景资源type
              },
              opHelper: {
                isSvip: false,
              },
              scenesId: data.id,
            });

            // this.closeSetting()
            scenesJson = null;
            this.soundHandle.addScenesSound(changeTime, addSounds);
            this.$store.commit("subtitle/addScenesSound", {
              changeTime,
              subtitles,
            });
            this.emitDurationLimit();
          });
        });
      });
    },
    continueScenes(data, index) {
      // 继续创作
      let changeTime = [0, 0];
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        changeTime[0] += this.TOOL.sprites[i].duration / 1000;
        if (this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
          // 场景页默认添加为10s长度
          changeTime[1] = changeTime[0] + 10;
          break;
        }
      }

      let scenesIndex = this.SelectScenes_Msg.index + 1;
      let jsonScenes = this.cardingJson(this.SelectScenes_Msg.toJson());
      //console.log(jsonScenes)

      this.TOOL.addScenes().then((scenes) => {
        this.TOOL.moveScenesTo(scenes.id, scenesIndex);
        this.TOOL.selectScenes(scenes).then((data) => {
          jsonScenes.duration = 10;
          let scale = this.TOOL.clientWidth / jsonScenes.resolution.width;
          scenes.toFromJson(jsonScenes, scale).then(() => {
            jsonScenes = null;
            //this.closeSetting()
            // this.$bus.emit('spritesFlagTime', {enterTime: -1})
            this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
            // 使用复制场景页的撤销
            let data = scenes.toJson(true);
            this.$bus.emit("judgeItemPayType_vue", {
              type: "scenes",
              id: data.id,
              option: {
                resourceId: data.resourceId, // 背景资源id
                fileType: 24, // 背景资源type
              },
              opHelper: {
                isSvip: false,
              },
              scenesId: data.id,
            });
            eve("undo_redo", null, { type: "copyScenes", data: data });
            this.emitDurationLimit();
          });
          this.soundHandle.addScenesSound(changeTime, []);
          this.$store.commit("subtitle/addScenesSound", {
            changeTime,
            subtitles: [],
          });
        });
      });
    },
    cardingJsonAction(json, type) {
      // 梳理json存*添/
      json.resolution = {
        height: 1080,
        width: 1920,
      };
      let scale = 1920 / this.TOOL.clientWidth;

      for (let j = 0, len = json.sprites.length; j < len; j++) {
        let item = json.sprites[j].outward;
        item.height = item.height * scale;
        item.width = item.width * scale;
        item.x = item.x * scale;
        item.y = item.y * scale;
        json.sprites[j].outward = item;

        let animation = json.sprites[j].stayEffect.animationGraphs;
        if (animation) {
          if ("toBounds" in animation[0]) {
            animation[0].toBounds.height = animation[0].toBounds.height * scale;
            animation[0].toBounds.width = animation[0].toBounds.width * scale;
            animation[0].toBounds.x = animation[0].toBounds.x * scale;
            animation[0].toBounds.y = animation[0].toBounds.y * scale;
          }
          if ("info" in animation[0]) {
            animation[0].info.height = animation[0].info.height *= scale;
            animation[0].info.width = animation[0].info.width *= scale;
            animation[0].info.points &&
              animation[0].info.points.forEach(function (point, i, arr) {
                for (var j = 0; j < point.length; j++) {
                  arr[i][j] = point[j] *= scale;
                }
              });
          }
          animation[0].path &&
            animation[0].path.forEach(function (val, i, arr) {
              arr[i] = val * scale;
            });
        }
      }
      // 镜头缩放
      json.cameras.forEach(function (camera, i, arr) {
        var m = camera.matrix;
        arr[i].matrix.w *= scale;
        arr[i].matrix.h *= scale;
        arr[i].matrix.x *= scale;
        arr[i].matrix.y *= scale;
      });
      return json;
    },
    collectScenes(item, index, outerItem) {
      if (this.SelectScenes_Msg.resourceId) {
        for (let j = 0; j < this.IsVipSprites.data.length; j++) {
          if (
            this.SelectScenes_Msg.resourceId ===
              this.IsVipSprites.data[j].resourceId &&
            this.UserEquity.exclusiveBtn
          ) {
            this.$modal.show("vipDialog", {
              msg: "该场景页为VIP素材，如需收藏，还请升级为企业会员。",
              target: "vip",
              type: "vip",
            });
            return;
          }
        }
      }
      let scenesDom = this.SelectScenes_Msg.element.content.get(0);
      this.$message("正在收藏中，请不要切换场景页");
      this.isUploadingScene = true;
      domtoimage
        .toBlob(scenesDom, { bgcolor: "#ffffff" })
        .then((dataUrl) => {
          let formDatas = new FormData();
          formDatas.append("imageName", dataUrl);

          this.uploadImage({ formDatas })
            .then((response) => {
              let scenesData = {},
                dataItem = this.cardingJsonAction(
                  this.SelectScenes_Msg.toJson(),
                  "save"
                ),
                imgUrl = response.data.thumbnailName;
              let ts = [0, 0];
              for (let i = 0; i < this.TOOL.sprites.length; i++) {
                if (this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
                  ts[1] = ts[0] + this.TOOL.sprites[i].duration / 1000;
                  break;
                }
                ts[0] += this.TOOL.sprites[i].duration / 1000;
              }
              dataItem.dubbing = this.soundHandle.getDubbingTS(ts);
              let subtitles = [];
              this.$store.commit("subtitle/getSubtitleTS", {
                timeSlot: ts,
                subtitles,
              });
              dataItem.subtitles = subtitles;
              scenesData.data = JSON.stringify(dataItem);
              scenesData.title = "我的场景页~";
              scenesData.thumbnailUrl = imgUrl;
              scenesData.direction =
                this.TOOL.optimized === "Horizontal" ? 1 : 2;
              this.uploadScene(scenesData)
                .then((resScenes) => {
                  this.$message({
                    message: "收藏场景成功",
                    type: "success",
                  });
                  this.setSceneLibStatus("pack-enter");
                  this.$bus.emit("collect-scene-sucess");
                  this.isUploadingScene = false;
                })
                .catch((error) => {
                  this.isUploadingScene = false;
                });
            })
            .catch((error) => {
              this.isUploadingScene = false;
            });
        })
        .catch((error) => {
          this.isUploadingScene = false;
        });
    },
    cardingJson(json) {
      // 梳理json存*添/
      json.resolution = {
        height: this.TOOL.clientHeight,
        width: this.TOOL.clientWidth,
      };

      let duration = json.duration,
        sprites = [];
      for (let j = 0, len = json.sprites.length; j < len; j++) {
        let enterEffect = json.sprites[j].enterEffect.duration;
        let stayEffect = json.sprites[j].stayEffect.duration;
        let startTime = json.sprites[j].startTime;

        if (enterEffect + stayEffect + startTime === duration) {
          let animation = json.sprites[j].stayEffect.animationGraphs;
          json.sprites[j].startTime = 0;
          json.sprites[j].enterEffect.duration = 0;
          json.sprites[j].enterEffect.type = "None";
          json.sprites[j].stayEffect = {
            data: null,
            duration: 10, // 停留一秒钟的时候改变这个参数
            hand: undefined,
            type: "None",
          };

          if (animation) {
            json.sprites[j].outward.height = animation[0].toBounds.height;
            json.sprites[j].outward.width = animation[0].toBounds.width;
            json.sprites[j].outward.x = animation[0].toBounds.x;
            json.sprites[j].outward.y = animation[0].toBounds.y;
            json.sprites[j].outward.rotation = animation[0].toRotation;

            json.sprites[j].stayEffect.animationGraphs = null;
          }
          sprites.push(json.sprites[j]);
        }
      }
      json.sprites = sprites;

      return json;
    },
    cardingCopyJson(json) {
      // 梳理json存*添/
      json.resolution = {
        height: this.TOOL.clientHeight,
        width: this.TOOL.clientWidth,
      };
      return json;
    },
    updateScenes(scenes = [], activeIndex = 0, { runType = "sequence" } = {}) {
      let arrTemp = scenes.map((scene) => ({
        data: scene,
        thumbnails: "",
        seleceScale: "",
        scale: "",
      }));
      let timeoutTime = scenes.length * 250;

      runType === "sequence" &&
        setTimeout(() => {
          // let sceneDataTasks = scenes.map(this.getSceneData);
          let arrSceneData = [];
          let sceneDataTasks = scenes.map((scene, i) => {
            let func = () => {
              let p = this.getSceneData(scene, i);
              return new Promise((resolve, reject) => {
                p.then((dataMsg) => {
                  arrSceneData.push(dataMsg);
                  resolve(dataMsg);
                });
              });
            };
            return func;
          });

          sequenceTasks(sceneDataTasks)
            .then(() => {
              this.scenesData = arrTemp;
              setTimeout(() => {
                this.scenesData = arrSceneData;
                this.scenesFlag = true;
                this.syncVideoSpritesAndVideoBg();
                this.isShowScenesLoading = false;
              }, 10);
            })
            .catch((err) => {
              console.warn(err);
            });
        }, timeoutTime);

      runType === "parallel" &&
        setTimeout(() => {
          // this.getScenesData();

          let sceneDataTasks = scenes.map(this.getSceneData);

          Promise.all(sceneDataTasks)
            .then((arrSceneData) => {
              this.scenesData = arrTemp;
              setTimeout(() => {
                this.scenesData = arrSceneData;
                this.scenesFlag = true;
              }, 10);
            })
            .catch((err) => {
              console.warn(err);
            });
        }, timeoutTime);

      this.setSelectScenes(this.TOOL.sprites[activeIndex]);
    },
    getSceneData(data, index) {
      let dataMsg = {
        data,
        thumbnails: "",
        seleceScale: "",
        scale: "",
      };
      return new Promise((resolve, reject) => {
        // if (!data.fromJsonLoadingState) {
        //   resolve(dataMsg);
        //   return;
        // }
        data.getThumbnails().then((data) => {
          dataMsg.thumbnails = data.dom;
          dataMsg.seleceScale = 260 / data.width;
          dataMsg.scale = 242 / data.width;
          // dataMsg.seleceScale = 0.3;
          // dataMsg.scale = 0.2;
          resolve(dataMsg);
        });
      });
    },
    syncVideoSpritesAndVideoBg() {
      this.$nextTick(() => {
        this.TOOL.sprites.forEach((scene) => {
          let $videoEl = $(this.$el).find(
            `[data-url="video-mark_${scene.id}"]`
          );
          scene.syncVideoBgTime($videoEl[0] || false);
          this.syncVideoSpriteTime(scene);
        });
      });
    },
    syncVideoBgTime(scene) {
      scene = scene || this.SelectScenes_Msg;
      let $videoEl = $(this.$el).find(`[data-url="video-mark_${scene.id}"]`);
      scene.syncVideoBgTime($videoEl[0] || false);
    },
    syncVideoSpriteTime(scene) {
      let videoSprite = (scene.sprites.filter(
        (sprite) => sprite.type === "Video"
      ) || [])[0];
      let videos = $(this.$el).find("video");
      videos.each((i, el) => {
        let id = $(el).parent().data("id");
        if (videoSprite && id === videoSprite.id) {
          videoSprite.syncCurrentTime(el);
        }
      });
    },
    openSceneEffectPopup(id, ev) {
      let myItem = this.scenesData.filter((item) => id === item.data.id)[0];
      let index = this.scenesData.indexOf(myItem);
      let egSence = this.TOOL.sprites[index - 1];
      if (egSence && egSence.fromJsonLoadingState < 1) {
        this.setSelectScenes(egSence);
      }
      console.log(ev, ev.pageY - 105, "<---------12");
      this.$bus.emit("FeaturesPop_vue", {
        name: "sceneEffect",
        type: 1,
        initialX: this.MaterialPane_Size.width - 20,
        initialY: ev.pageY - 105,
        scenesMsg: {
          beforeEffect: this.TOOL.sprites[index - 1],
          afterEffect: this.TOOL.sprites[index],
        },
      });
    },
    moveScenesMsgFs(data) {
      for (let i = 0; i < this.scenesData.length; i++) {
        let sprite = this.scenesData[i].data;
        if (
          sprite.id ===
          data /* && this.SelectScenes_Msg.fromJsonLoadingState === 2 */
        ) {
          this.SelectScenes_Msg.getThumbnails().then((data) => {
            if (!data) {
              return;
            }
            let item = this.scenesData[i] || {};
            item.thumbnails = data.dom;
            item.seleceScale = 260 / data.width;
            item.scale = 242 / data.width;
            this.scenesData.push([]);
            this.scenesData.pop([]);

            this.$nextTick(() => {
              this.syncVideoBgTime(this.SelectScenes_Msg);
              this.syncVideoSpriteTime(this.SelectScenes_Msg);
            });
          });
          break;
        }
      }
    },
    getDisplayEffectName(index, data) {
      let scene = data[index - 1];
      return scene.data.effect.code;
    },
    getEffectName(index, data) {
      let scene = data[index - 1];
      let code = scene.data.effect.code;
      //console.log(data);
      switch (code) {
        case "None":
          return "添加转场";
        case "ZoomIn":
          return "放大";
        case "ZoomOut":
          return "缩小";
        case "Fade":
          return "淡入淡出";
        case "RightIn":
          return "从左移入";
        case "LeftIn":
          return "从右移入";
        case "DownIn":
          return "从上移入";
        case "UpIn":
          return "从下移入";
        case "Hands":
          return "手势下移";
        case "WhiteColorSmear":
          return "白色涂抹";
        case "Clipboard":
          return "电影打板";
        case "TvNoise":
          return "电视雪花";
        case "PullDown":
          return "帘子下移";
        case "Roller":
          return "滚筒刷";
        case "Sqweegee":
          return "玻璃刮";
        case "Poof":
          return "爆出";
        case "BlueColorSmear":
          return "蓝色涂抹";
        case "Swipe":
          return "横向划出";
        case "SliceVertical":
          return "垂直划像";
        case "FanUp":
          return "扇叶向上";
        case "FanDown":
          return "扇叶向下";
        case "SpiralzTech":
          return "蓝色螺旋";
        case "Spiralz":
          return "灰色螺旋";
        case "SliceHorizontal":
          return "水平划像";
        case "SliceCenter":
          return "中间划像";
        case "Slice":
          return "对角划像";
        case "FlipBook":
          return "翻书";
        case "RowSpread":
          return "行铺";
        case "Mosaic":
          return "像素溶解";
        case "CameraUp":
          return "镜头上移";
        case "CameraDown":
          return "镜头下移";
        case "CameraLeft":
          return "镜头左移";
        case "CameraRight":
          return "镜头右移";
      }
    },
    onListScroll() {
      if (this.tid) {
        return;
      }
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "sceneEffect",
        type: 1,
      });
      this.tid = setTimeout(() => {
        this.tid = null;
      }, 1000);
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
      this.$bus.emit("scene_click", {});
    },
    emitDurationLimit() {
      let type = 'save';
      let timeAll = this.TOOL.getDuration();
      if (this.UserEquity.time && timeAll > this.UserEquity.time) {
        type = 'danger';
      } else if (this.UserEquity.time && timeAll >= this.UserEquity.time - 10000) {
        type = 'warning';
      }
      eve("totalTime_danger", null, { timeAll: timeAll, type });
    }
  },
  components: {
    draggable,
    fromPPT,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Scenes {
  position: relative;
  z-index: 11;
  height: 100%;
  overflow: hidden;
  cursor: default;
  .inner {
    width: 290px;
    height: 100%;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }
  .hidescenes {
    position: absolute;
    top: 0;
    right: -20px;
    bottom: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 49px;
    margin: auto;
    font-size: 20px;
    font-weight: bold;
    background-color: #fff;
    box-shadow: 2px 0 4px 0 rgba(44, 75, 248, 0.2);
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    i {
      display: block;
      width: 9.3px;
      height: 16px;
    }
    .arrow-left {
      background: url("../../static/svg/left-arrow.svg") no-repeat center;
      &:hover {
        background: url("../../static/svg/left-arrow-active.svg") no-repeat
          center;
      }
    }
    .arrow-right {
      background: url("../../static/svg/right-arrow.svg") no-repeat center;
      &:hover {
        background: url("../../static/svg/right-arrow-active.svg") no-repeat
          center;
      }
    }
  }
  .topBar {
    display: flex;
    width: 100%;
    .newBtn,
    .scenesBtn {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      width: 125px;
      height: 40px;
      color: #474261;
      border: 1px solid #d9ddea;
      border-radius: 4px;

      > span {
        display: inline-block;
        font-size: 14px;
      }

      &:hover {
        color: #fff;
        background-color: #5778fb;
        border-color: #5778fb;
        cursor: pointer;
      }
    }
    .newBtn {
      margin: 16px 12px 0 14px;
      > div {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 8px;
        background-image: url(../../static/svg/materialPane/scenes/createScene.svg);
        background-repeat: no-repeat;
        background-size: cover;
      }
      &:hover {
        > div {
          background-image: url(../../static/svg/materialPane/scenes/createScene-active.svg);
        }
      }
    }
    .scenesBtn {
      margin: 16px 14px 0 0;
      > div {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 8px;
        background-image: url(../../static/svg/materialPane/scenes/sceneLib.svg);
        background-repeat: no-repeat;
        background-size: cover;
      }
      &:hover {
        > div {
          background-image: url(../../static/svg/materialPane/scenes/sceneLib-active.svg);
        }
      }
    }
  }
  .labelNum {
    position: relative;
    width: 100%;
    height: 20px;
    margin-top: 20px;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
  }

  .scenesGrid {
    flex-grow: 1;
    width: 100%;
    height: 0;
    margin-top: 8px;
  }

  .scenesArray {
    overflow-x: hidden;
    overflow-y: scroll;
    // width: calc(100% + 18px);
    height: 100%;

    #scenesDrag {
      width: 100%;

      .scenesThumbnails {
        position: relative;
        width: 100%;
        height: 115px;
        background: #fff;
        transition: all 0.3s;

        .scenes_animation {
          position: absolute;
          top: -56px;
          left: 50%;
          margin-left: -59px;
          z-index: 5;
          width: 118px;
          border: 1px solid #d1d4dd;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover {
            border: 1px solid #9592a7;
            i {
              color: #474261;
            }
            span {
              font-weight: bold;
            }
          }
          > i {
            font-size: 16px;
            margin: 0 10px 0 18px;
            color: #7a8298;
          }
          > span {
            color: #424f61;
            font-size: 12px;
          }
        }
        div {
          position: absolute;
          z-index: 5;
        }
        &.active {
          .thumbnails {
            border: 2px solid #5778fb;

            box-shadow: 0px 3px 16px rgba(61, 81, 160, 0.1);
          }
        }
        .thumbnails {
          overflow: hidden;
          box-shadow: 0px 1px 10px rgba(61, 81, 160, 0.1);
          border: 1px solid #fff;
          border-radius: 4px;
          transition: all 0.3s;
          margin: 0 auto;
          position: relative;

          .htmlT {
            position: absolute;
            z-index: 5;
            top: 0;
            left: 0;
            margin: auto;
            transform: skewX(0);
            transition: all 0.3s;
            border-radius: 4px;
          }

          .thumbnailsMask {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            overflow: hidden;
            width: 100%;
            height: 100%;

            .maskBtn {
              top: 0;
              left: 0;
              z-index: 10;
              overflow: hidden;
              width: 100%;
              height: 100%;
              background: transparent;
              transition: all 0.3s;
              opacity: 0;

              &:hover {
                background: -webkit-linear-gradient(
                  rgba(255, 255, 255, 0),
                  rgba(0, 0, 0, 0.6)
                ); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(
                  rgba(255, 255, 255, 0),
                  rgba(0, 0, 0, 0.6)
                ); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(
                  rgba(255, 255, 255, 0),
                  rgba(0, 0, 0, 0.6)
                ); /* Firefox 3.6 - 15 */
                background: linear-gradient(
                  rgba(255, 255, 255, 0),
                  rgba(0, 0, 0, 0.6)
                ); /* 标准的语法（必须放在最后） */
                opacity: 1;
              }

              .scenesSetting {
                position: absolute;
                right: 0;
                bottom: 10px;
                width: 38px;
                color: #fff;
                font-size: 23px;
                text-align: left;
                cursor: pointer;
              }
              .btn-bg {
                position: absolute;
                width: 22px;
                height: 22px;
                background: rgba(110, 110, 110, 0.8);
                border-radius: 50%;
                z-index: 2;
                &:hover {
                  background: rgba(87, 120, 251, 0.8);
                }
              }
              .scenesRm {
                position: relative;
                width: 12px;
                height: 12px;
                margin: 50% 0 0 50%;
                background-image: url(../../static/svg/materialPane/scenes/scene-del.svg);
                background-repeat: no-repeat;
                background-size: cover;
                transform: translate(-50%, -50%);
                cursor: pointer;
              }
              .scenes-copy {
                position: relative;
                width: 12px;
                height: 11px;
                margin: 50% 0 0 50%;
                background-image: url(../../static/svg/materialPane/scenes/scene-copy.svg);
                background-repeat: no-repeat;
                background-size: cover;
                transform: translate(-50%, -50%);
                cursor: pointer;
              }
              .scenes-continue {
                position: relative;
                width: 12px;
                height: 12px;
                margin: 50% 0 0 50%;
                background-image: url(../../static/svg/materialPane/scenes/scene-continue.svg);
                background-repeat: no-repeat;
                background-size: cover;
                transform: translate(-50%, -50%);
                cursor: pointer;
              }
              .scenes-collect {
                position: relative;
                display: block;
                font-size: 20px;
                transform: scale(0.65);
                cursor: pointer;
                color: #fff;
                top: -3px;
                &.active {
                  color: #fd6c6c;
                }
              }
            }
          }
          .verticalMask {
            &:before,
            &:after {
              content: "";
              position: absolute;
              top: 0;
              height: 100%;
              background: url(/static/animengine/img/diagonal.png);
              background-size: 5px;
            }
            &:before {
              right: 0;
              width: 90px;
            }
            &:after {
              left: 0;
              width: 90px;
            }
          }
          .verticalMaskWiidth {
            &:before,
            &:after {
              width: 80px;
            }
          }
        }
        .scene-duration {
          position: absolute;
          right: 6px;
          bottom: 6px;
          z-index: 10;
          width: 36px;
          height: 20px;
          line-height: 20px;
          color: #fff;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.6);
          border-radius: 4px;
        }
        .thumbnails_s {
          width: 262px;
          height: 146px;
        }
        .thumbnails_c {
          width: 244px;
          height: 136px;
          // margin-left: 14px;
        }
      }
    }
  }
  .add-scenes {
    width: 100%;
    height: 100%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 119px;
      height: 65px;
      margin: 0 auto;
      border-top: 2px solid #d4d4e7;
      .add-btn {
        display: inline-block;
        width: 31px;
        height: 20px;
        background: url("../../static/svg/add.svg") no-repeat center;
        cursor: pointer;
        &:hover,
        &:active {
          background: url("../../static/svg/add-active.svg") no-repeat center;
        }
      }
    }
  }
}

.scenes-loading-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/Scenes.vue